<template>
  <!-- S:{{ $store.state.data.users }} -->

  <ComboBoxInput
    v-model:model-value="values_clone.selected_team_member"
    name="team_member"
    :is-multiple="false"
    :disabled="disabled"
    :items="$store.state.data.users"
    classes="w-full mr-2 relative dark:text-white"
    label-attr="full_name"
    value-attr="id"
    label=""
    :placeholder="$t('Select team members')"
    :show-label="false"
    :floating-label="false"
    :allow-null="false">
    <template #item="{ item, active }">
      <li :class="[active ? 'text-white bg-blue' : 'text-gray-900 dark:text-white', 'cursor-default relative py-2 pl-4 pr-4 group/name']">
        <div class="flex items-center">
          <img
            v-if="item.avatar"
            class="inline-block rounded-full h-9 w-9 object-cover"
            :src="item.avatar"
            onerror="this.onerror=null; this.src=window.default_avatar;"
            alt="">
          <Avatar
            v-else
            :hover-effect="true"
            :first-name="item.first_name"
            :last-name="item.last_name"
            class="group-hover/name:bg-cyan-500" />
          <div class="ml-3">
            <p class="h-full text-sm font-normal text-gray-700 dark:text-white group-hover/name:text-white">
              {{ Record.from(item).full_name }}
            </p>
            {{ item.email }}
          </div>
        </div>
      </li>
    </template>
  </ComboBoxInput>
</template>

<script>
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import Avatar from "@/components/shared/Avatar.vue"

import { Record } from "@/models/record"

export default {
  components: { ComboBoxInput, Avatar },
  props: { selectedNode: null },
  emits: ["updateValues"],

  data() {
    return {
      values_clone: {
        selected_team_member: null,
        title: "",
        description: ""
      },
      disabled: false,
      Record
    }
  },
  watch: {
    values_clone: {
      deep: true,
      handler() {
        this.handleUpdateValues()
      }
    }
  },

  created() {
    this.init()
  },

  methods: {
    handleUpdateValues() {
      let valid_calc = true
      if (!this.values_clone?.selected_team_member) {
        valid_calc = false
      }

      const data = {
        ...this.values_clone,
        selected_team_member: this.values_clone.selected_team_member,
        title: this.values_clone.title,
        description: this.values_clone.description,
        valid: valid_calc,
        meta: {
          name: this.$store.state.data.users.find((u) => u.id == this.values_clone.selected_team_member)?.full_name,
          title: this.values_clone.title
        }
      }
      this.$emit("updateValues", data)
    },
    init() {
      this.values_clone = this.$utils.clone(this.selectedNode.data.values)

      // Initialize title and description if they don't exist
      if (!this.values_clone.title) {
        this.values_clone.title = ""
      }
      if (!this.values_clone.description) {
        this.values_clone.description = ""
      }
    }
  }
}
</script>
